module.exports = __webpack_public_path__ + "e-learning-app/static/img/suiji.befaf3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-course/img/tiku/suiji.png
// module id = SIMz
// module chunks = 1